import React, { useState, useRef, useEffect } from "react";
import { FaPlay, FaPause } from "react-icons/fa";

const AudioPlayer = ({ src, title }) => {
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const [duration, setDuration] = useState(0);

  // Update progress bar
  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;
    const update = () => setProgress(audio.currentTime);
    audio.addEventListener("timeupdate", update);
    return () => audio.removeEventListener("timeupdate", update);
  }, []);

  // Handle play / pause toggle
  const togglePlay = () => {
    const audio = audioRef.current;
    if (!audio) return;
    if (isPlaying) audio.pause();
    else audio.play();
    setIsPlaying(!isPlaying);
  };

  const handleLoaded = () => setDuration(audioRef.current.duration || 0);
  const handleSeek = (e) => {
    const time = e.target.value;
    audioRef.current.currentTime = time;
    setProgress(time);
  };

  return (
    <div className="w-full max-w-lg mx-auto bg-black/60 backdrop-blur-md border border-white/10 rounded-2xl p-4 flex flex-col gap-3 shadow-lg">
      <div className="flex items-center gap-4">
        <button
          onClick={togglePlay}
          className="flex items-center justify-center w-14 h-14 rounded-full bg-gradient-to-br from-indigo-600 to-purple-700 hover:scale-110 transition-transform shadow-md"
        >
          {isPlaying ? (
            <FaPause className="text-white text-xl" />
          ) : (
            <FaPlay className="text-white text-xl pl-1" />
          )}
        </button>

        <div className="flex-1">
          <p className="font-semibold text-white truncate">{title}</p>
          <input
            type="range"
            min={0}
            max={duration}
            step="0.1"
            value={progress}
            onChange={handleSeek}
            className="w-full accent-indigo-500 cursor-pointer"
          />
        </div>
      </div>

      <audio
        ref={audioRef}
        src={src}
        onLoadedMetadata={handleLoaded}
        onEnded={() => setIsPlaying(false)}
      />
    </div>
  );
};

export default AudioPlayer;
